define([
    "csi/access/_base",
    "csi/access/access",
    "csi/access/full",
    "csi/access/readOnly"
], function(csiAccess,access,full,readOnly) {

// add view security configuration

	

	var soAdminRoles = ['Stock Order Administrator','Stock Order Requester'];
	var supplierRequestEditRoles = ['Supplier Request Administrator', 'Supplier Request Editor'];

	csiAccess.addViewRoles({
		"_CS_ApparelViews":{
			"MaterialSupplierRequests":{
				"CreateStockOrder":access(full(soAdminRoles))
			},
			"StyleSupplierRequests":{
				"CreateStockOrder":access(full(soAdminRoles))
			}
		},
		"Product":{
			"SupplierRequests":{
				"CreateStockOrder":access(full(soAdminRoles))
			}
		},
		"SupplierRequest":{
			"StockOrder":{
				"CreateStockOrder":access(full(soAdminRoles))
			},
			"StateHeader":{
				"CloseRequest":access(full(supplierRequestEditRoles), full(soAdminRoles)),
				"ReIssueRequest":access(full(supplierRequestEditRoles), full(soAdminRoles))
			}
		}
	});
});